import * as React from "react";

interface DisclaimerProps {
    text?: string;
    children?: React.ReactNode;
}

// tslint:disable-next-line:no-var-requires
const style = require("./Disclaimer.scss");

const Disclaimer = ({ children }: DisclaimerProps) => {
    return (
        <div className={style.disclaimer}>
            <span>{children}</span>
        </div>
    );
};

export default Disclaimer;
